<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('PitchforkTool', function() {
            return {
                group: 'Lines', category: 'Pitchforks', icon: this.getIcon('pitchfork'),
                type: 'Pitchfork',
                name: 'Pitchfork',
                hint: "Andrew's Pitchfork",
                data: [],
                settings: {},
                mods: {
                    'Inside': {
                        settings: { inside: true },
                        category: 'Pitchforks',
                        icon: this.getIcon('pitchfork'),
                        hint: 'Inside Pitchfork',
                        name: 'Inside Pitchfork'
                    }
                }
            }
        }, s => s.inside ? 'Inside Pitchfork' : s.schiff ? 'Schiff Pitchfork' : 'Pitchfork')
</script>
